
import { Check, RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ResponseStrategySectionProps {
  isLatestAIMessage?: boolean;
  refundApproved?: boolean;
  onResponseStrategySelect?: (strategy: "accept" | "negotiate" | "decline") => void;
}

const ResponseStrategySection = ({
  isLatestAIMessage,
  refundApproved,
  onResponseStrategySelect
}: ResponseStrategySectionProps) => {
  if (!isLatestAIMessage || refundApproved === undefined || !onResponseStrategySelect) {
    return null;
  }

  return (
    <div className="mt-3 space-y-2">
      <p className="text-sm font-medium">How would you like to respond to this offer?</p>
      <div className="flex flex-wrap gap-2">
        <Button 
          variant="outline" 
          size="sm"
          className="flex items-center gap-1"
          onClick={() => onResponseStrategySelect("accept")}
        >
          <Check className="h-4 w-4" />
          Accept Offer
        </Button>
        
        <Button 
          variant="outline" 
          size="sm"
          className="flex items-center gap-1"
          onClick={() => onResponseStrategySelect("negotiate")}
        >
          <RefreshCw className="h-4 w-4" />
          Keep Negotiating
        </Button>
        
        <Button 
          variant="outline" 
          size="sm"
          className="flex items-center gap-1"
          onClick={() => onResponseStrategySelect("decline")}
        >
          <X className="h-4 w-4" />
          Decline Offer
        </Button>
      </div>
    </div>
  );
};

export default ResponseStrategySection;
